import { Button, Modal } from '@/components/basic';
import { LoadingSpinner } from '@/components/util/LoadingSpinner';
import { api } from '@/lib/api/api';
import { External } from '@gettactic/api';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

type Props = {
  onClose: () => void;
  externals: External[];
  invalidateQuery: () => Promise<void>;
};

export const DeleteExternalId = ({
  onClose,
  externals,
  invalidateQuery
}: Props) => {
  const { handleSubmit } = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const onDeleteSubmit = async () => {
    setLoading(true);
    const results = await Promise.all(
      externals.map(
        async (external) =>
          await api.client.externals.deleteExternalId(external.id)
      )
    );
    if (results.find((res) => res.error)) {
      toast.error("Sorry we couldn't delete this external IDs");
    } else {
      toast.success('Deleted successfully');
      onClose();
    }
    setLoading(false);
    await invalidateQuery();
  };

  return (
    <form
      id="deleteHour"
      onSubmit={(ev) => {
        ev.stopPropagation();
        handleSubmit(onDeleteSubmit)(ev);
      }}
    >
      <div>
        <div className="mt-4">
          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg
                className="h-6 w-6 text-red-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              {externals.length > 1 ? (
                <p className="text-base text-gray-800">
                  Are you sure want to delete? You cannot restore these items
                  once they has been deleted.
                </p>
              ) : (
                <p className="text-base text-gray-800">
                  Are you sure you want to delete? You cannot restore this item
                  once it has been deleted.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal.Footer>
        <Button
          className="w-full sm:w-auto"
          layout="squared"
          variant="white"
          font="boldGray"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          className="w-full sm:ml-3 sm:w-auto"
          layout="squared"
          variant="primary"
          type="submit"
          form="deleteHour"
          disabled={loading}
        >
          {loading ? (
            <LoadingSpinner color="text-white" />
          ) : (
            <span>Delete</span>
          )}
        </Button>
      </Modal.Footer>
    </form>
  );
};

export default DeleteExternalId;
